export default process.env;



// WEBPACK FOOTER //
// ./src/@utils/Settings.web.js